module.exports = __webpack_public_path__ + "assets/gongwenjiaohuan.4253fa25.svg";